// src/i18n/index.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ru from './locales/ru.json';
import ky from './locales/ky.json';
import kk from './locales/kk.json';
import uz from './locales/uz.json';
import tr from './locales/tr.json';
import tg from './locales/tg.json';
import tk from './locales/tk.json';

export const LANGUAGES = [
  { code: 'en', name: 'English',     flag: '🇬🇧' },
  { code: 'ru', name: 'Русский',     flag: '🇷🇺' },
  { code: 'ky', name: 'Кыргызча',    flag: '🇰🇬' },
  { code: 'kk', name: 'Қазақша',     flag: '🇰🇿' },
  { code: 'uz', name: "O'zbekcha",   flag: '🇺🇿' },
  { code: 'tr', name: 'Türkçe',      flag: '🇹🇷' },
  { code: 'tg', name: 'Тоҷикӣ',      flag: '🇹🇯' },
  { code: 'tk', name: 'Türkmen',     flag: '🇹🇲' },
];

const SAVED_LANG_KEY = 'alsatuu.lang';

const savedLang = (() => {
  try { return localStorage.getItem(SAVED_LANG_KEY); } catch (e) { return null; }
})();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
      ky: { translation: ky },
      kk: { translation: kk },
      uz: { translation: uz },
      tr: { translation: tr },
      tg: { translation: tg },
      tk: { translation: tk },
    },
    lng: savedLang || 'en', // по умолчанию английский
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export function setLanguage(code) {
  i18n.changeLanguage(code);
  try { localStorage.setItem(SAVED_LANG_KEY, code); } catch (e) {}
}

export function getCurrentLanguage() {
  return i18n.language;
}

export default i18n;
